export default "__VITE_ASSET__oAW5HAcp__"